export const cavettoOptions = [
    {
        name: 'Ingen',
    },
    {
        name: 'Bakplate sømløs. Hulkil radie 6mm',
        helpText: 'Ferdig pålimt på plate',
    },
    {
        name: 'Bakplate sømløs. Hulkil radie 12mm',
        helpText: 'Ferdig pålimt på plate',
    },
    {
        name: 'Bakplate løs',
        helpText: 'Fuges med silikon mellom benkeplate og bakplate',
    },
]

export function getCavettoHelpText(cavettoName: string): string | null {
    const option = cavettoOptions.find(c => c.name === cavettoName);
    if (option === undefined) {
        return null;
    }

    return option.helpText || null;
}